import { observable, computed } from 'mobx';

export interface AppSetting {
    itemValue: string;
    readonly name: string;
    readonly dataType: string;
    readonly description: string;
    readonly category: string;
}

export class AppSettingsStore {

    @observable settings: AppSetting[] = [];

    load(settings: AppSetting[]) {
        if (settings) this.settings = settings;
    }

    @computed get all() {
        return this.settings;
    }
}

export default new AppSettingsStore()